const getters = {
    sidebar: state => state.app.sidebar,
    size: state => state.app.size,
    // device: state => state.app.device,
    language: state => state.app.language,
    choseCustomer: state => state.app.currentCustomerCode,
    choseStore: state => state.app.currentStoreCode,
    goodsFields: state => state.app.goodsFields,
    custFunConfig: state => state.app.custFunConfig,
    storeConfig: state => state.app.storeConfig,
    // csrftokenSwitch: state => state.app.csrftokenSwitch,
    // visitedViews: state => state.tagsView.visitedViews,
    // cachedViews: state => state.tagsView.cachedViews,
    token: state => state.user.token,
    name: state => state.user.name,
    roles: state => state.user.roles,
    globalConfig: state => state.user.globalConfig,
    // avatar: state => state.user.avatar,
    // introduction: state => state.user.introduction,
    permission_routes: state => state.permission.routes,
    btnPermission: state => state.permission.btnPermission,
    errorLogs: state => state.errorLog.logs
};
export default getters;
